<template>
    <el-cascader v-model="model[data.fieldId]"
                 :options="cascaderOptions"
				 :disabled="disabled"
				 :show-all-levels="data.setting.showAllLevels"
				 :collapse-tags="data.setting.collapseTags"
				 :props="{
					checkStrictly: data.setting.checkStrictly,
					multiple: data.setting.multiple 
				 }"
                 style="width: 100%"
				 @change="cascaderChange"></el-cascader>
</template>

<script>
import { isHaveKey } from '../../utils/tool'

export default {
	name: 'TpCascader',
	props: {
		data: {
			type: Object,
			required: true
		},
		model: Object
	},
	inject: [ 'customFormOptions' ],
	computed: {
		disabled() {
			if (isHaveKey(this.customFormOptions[this.data.fieldId], 'disabled')) {
				return this.customFormOptions[this.data.fieldId].disabled(this.model[this.data.fieldId])
			} else {
				return false
			}
		},

		cascaderOptions() {
			if (isHaveKey(this.customFormOptions[this.data.fieldId], 'options')) {
				// if (this.customFormOptions[this.data.fieldId].options.length > 0 && this.model[this.data.fieldId] === '') {
				// 	this.model[this.data.fieldId] = this.customFormOptions[this.data.fieldId].options[0].value
				// }
				return this.customFormOptions[this.data.fieldId].options
			} else {
				return []
			}
		}
	},
	methods: {
		cascaderChange(val) {
			if (isHaveKey(this.customFormOptions[this.data.fieldId], 'change')) {
				this.customFormOptions[this.data.fieldId].change(val)
			}
		}
	},
	created() {
		console.log(this.data)
	}
}
</script>

